import Invoice from './invoiceResource';
import transformError from '../shared/transformers/errorTransformer';

function getInvoiceRange() {
  return Invoice.getInvoiceRange()
    .then(({ body: { invoice_ranges: ranges } }) => ranges)
    .catch(transformError);
}

function getInvoiceFile(id) {
  return Invoice.get({ id }).then(response => {
    const {
      bodyBlob: { type },
    } = response;
    if (type === 'application/json') {
      const { body } = response;
      return {
        ...body,
        noContent: true,
      };
    }
    return response.blob();
  });
}

function sendInvoiceToEmail({ id, email }) {
  return Invoice.sendInvoiceToEmail({
    id,
    send_to: email,
  }).catch(transformError);
}

export default {
  getInvoiceRange,
  getInvoiceFile,
  sendInvoiceToEmail,
};
